import PropTypes from "prop-types";
import React from "react";

/**
 * Button component to toggle display of older recruiting history activities
 */
const HistoryToggleButton = ({ onClick, isHidden, count = 0 }) => (
  <button
    type="button"
    onClick={onClick}
    className="btn btn-secondary btn-wide btn-sm"
  >
    {isHidden ? (
      <>{count} older activities, click to show recruiting history</>
    ) : (
      <>Hide recruiting history</>
    )}
  </button>
);

HistoryToggleButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isHidden: PropTypes.bool.isRequired,
  count: PropTypes.number,
};

export default HistoryToggleButton;
